import styled from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

export const RadioInput = styled.input`
  cursor: pointer;
  appearance: radio;

  &:after {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    top: -2px;
    left: -1px;
    position: relative;
    background-color: ${nuDSColor('black')};
    content: '';
    display: inline-block;
    visibility: visible;
    border: 2px solid white;
  }

  &:checked:after {
    background-color: ${nuDSColor('primary', 'defaultL40')};
  }
`;
